import { ApolloClient, NormalizedCacheObject } from '@apollo/client';

import { TsRestClient } from '@eluve/api-client-provider';
import { Logger } from '@eluve/logger';

import { TaskHandlerRegistry } from '../types';

import { addAppointmentTagHandler } from './addAppointmentTagHandler';
import { generateNoteHandler } from './generateNoteHandler';
import { markChunkFinalHandler } from './markChunkFinalHandler';
import { markClientAudioCompletedAtHandler } from './markClientAudioCompletedAtHandler';
import { prepareAudioRecordsHandler } from './prepareAudioRecordsHandler';
import { updateSegmentHandler } from './updateSegmentHandler';

export const createTaskHandlers = ({
  apolloClient,
  apiClient,
  logger,
}: {
  apolloClient: ApolloClient<NormalizedCacheObject>;
  apiClient: TsRestClient;
  logger: Logger;
}): TaskHandlerRegistry => {
  return {
    'TASK.GENERATE_NOTE': generateNoteHandler({
      client: apolloClient,
      apiClient,
      logger,
    }),
    'TASK.MARK_CHUNK_FINAL': markChunkFinalHandler({
      client: apiClient,
      logger,
    }),
    'TASK.PREPARE_AUDIO_RECORDS': prepareAudioRecordsHandler({
      client: apiClient,
      logger,
    }),
    'TASK.UPDATE_SEGMENT_RECORDING_ENDED_AT': updateSegmentHandler({
      client: apolloClient,
      logger,
    }),
    'TASK.MARK_CLIENT_AUDIO_COMPLETED_AT': markClientAudioCompletedAtHandler({
      logger,
      apolloClient,
    }),
    'TASK.ADD_APPOINTMENT_TAG': addAppointmentTagHandler({
      client: apiClient,
      logger,
    }),
  };
};
